<template>
  <router-link v-for="item in navigationItems"
               :key="item.path"
               :to="item.path"
               class="mainMenuItem"
  >
        <component :is="item.meta.icon" aria-hidden="true" class="mainMenuItemIcon" />
        {{ item.name }}
  </router-link>
</template>

<script>
import {
  HomeIcon,
  BookmarkIcon,
  CubeTransparentIcon,
  UserIcon,
  CurrencyDollarIcon,
  DocumentTextIcon,
  UsersIcon,
  UserGroupIcon,
  LightBulbIcon,
}
  from '@heroicons/vue/outline'

export default {
  name: "TheMainMenu",
  components: {
    HomeIcon,
    BookmarkIcon,
    CubeTransparentIcon,
    UserIcon,
    UserGroupIcon,
    CurrencyDollarIcon,
    DocumentTextIcon,
    UsersIcon,
    LightBulbIcon
  },
  data(){
    return{

    };
  },
  computed:{
    navigationItems(){
      const navItems = [];

      for( const item of this.$router.options.routes)
      {
        //console.log('router item ', item);
        if( item.meta.showInMainMenu )
        {
          navItems.push(item);
        }
      }
      return navItems;
    }
  }
}
</script>